export default __webpack_public_path__ + "imgs/price_bg.8f5ac69c.jpg";